import { render, staticRenderFns } from "./ManuallyReward.vue?vue&type=template&id=4507903b&scoped=true&"
import script from "./ManuallyReward.vue?vue&type=script&lang=ts&"
export * from "./ManuallyReward.vue?vue&type=script&lang=ts&"
import style0 from "./ManuallyReward.vue?vue&type=style&index=0&id=4507903b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4507903b",
  null
  
)

export default component.exports